import { useState, Dispatch, SetStateAction } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { MenuItem, Select, Button, SelectChangeEvent } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  useLazyExportUserReportListQuery,
  useLazyExportTransactionsListQuery,
} from "../../services/userReport";
import { showError } from "../../helpers";
import dayjs from "dayjs";
import type { DateRangeType } from "./types";

interface ReportsTopbarPropsWithPagination {
  page: number;
  pageSize: number;
  showRedemptionType?: boolean;
  type?: string;
  setDateRange?: Dispatch<SetStateAction<DateRangeType | null>>;
  setDateRange2?: Dispatch<SetStateAction<DateRangeType | null>>;
  setSelectRange?: Dispatch<SetStateAction<string>>;
}
interface ReportsTopbarProps {
  page: number;
  limit: number;
  dateFrom: DateRangeType | null;
  dateTo: DateRangeType | null;
}
function ReportsTopbar({
  page,
  pageSize,
  showRedemptionType = false,
  type,
  setDateRange = () => {},
  setDateRange2 = () => {},
  setSelectRange = () => {},
}: ReportsTopbarPropsWithPagination) {
  const [Range, setRange] = useState("default");
  const [redemptionType, setRedemptionType] = useState("default");
  const [dateRange1, setDateRange1] = useState<DateRangeType | null>(null);
  const [dateRange3, setDateRange3] = useState<DateRangeType | null>(null);

  const [exportUserReportList] = useLazyExportUserReportListQuery();
  const [exportTransactionsList] = useLazyExportTransactionsListQuery();

  const handleRangeChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setRange(value);
    setSelectRange?.(value);
  };

  const handleRedemptionTypeChange = (event: SelectChangeEvent) => {
    const value = event.target.value as string;
    setRedemptionType(value);
  };

  const handleExport = async () => {
    try {
      console.log(type);
      const formatDate = (
        date: Date | string | null | undefined
      ): string | undefined => {
        if (!date) return undefined;
        if (date instanceof Date) return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
        return date; // Already a string
      };

      const params = {
        page,
        limit: pageSize,
        dateFrom: dateRange1
          ? dayjs(dateRange1).utc().startOf("day").format()
          : "",
        dateTo: dateRange3 ? dayjs(dateRange3).utc().endOf("day").format() : "",
      };

      const response = await (type === "UserReport"
        ? exportUserReportList(params).unwrap()
        : exportTransactionsList(params).unwrap());

      console.log("Export response:", response);
      if (response?.data) {
        // Create a temporary link to trigger the download
        const link = document.createElement("a");
        link.href = response.data;
        link.download = `${type}_${new Date().getTime()}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Optional: Show success message
        // showSuccess('Report exported successfully!');
      }
    } catch (error: any) {
      console.error("Export failed:", error);
      showError(error?.data?.message || "Failed to export report");
    }
  };

  return (
    <div className="table_header">
      <div className="left_s">
        <div className="form">
          {showRedemptionType && (
            <Select
              value={redemptionType}
              onChange={handleRedemptionTypeChange}
            >
              <MenuItem disabled value="default">
                Select Type
              </MenuItem>
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="promotion">Promotion</MenuItem>
              <MenuItem value="reward">Reward</MenuItem>
            </Select>
          )}
          <Select fullWidth value={Range} onChange={handleRangeChange}>
            <MenuItem disabled value="default">
              Select Date Range
            </MenuItem>
            <MenuItem value="1">Day</MenuItem>
            <MenuItem value="2">Week</MenuItem>
            <MenuItem value="3">Monthly</MenuItem>
            {/* <MenuItem value="4">Yearly</MenuItem> */}
            <MenuItem value="5">Custom Range</MenuItem>
          </Select>
          {Range === "5" && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker<dayjs.Dayjs>
                className="form_control"
                value={null}
                slots={{
                  openPickerIcon: () => (
                    <img src="/static/images/date_icon.svg" alt="Pick date" />
                  ),
                }}
                onChange={(newValue) => {
                  setDateRange(newValue ? newValue.format("YYYY-MM-DD") : null);
                  setDateRange1(
                    newValue ? newValue.format("YYYY-MM-DD") : null
                  );
                }}
                slotProps={{
                  textField: {
                    placeholder: "Start Date",
                    fullWidth: true,
                    hiddenLabel: true,
                  },
                }}
              />
              <DatePicker<dayjs.Dayjs>
                className="form_control"
                value={null}
                slots={{
                  openPickerIcon: () => (
                    <img src="/static/images/date_icon.svg" alt="Pick date" />
                  ),
                }}
                onChange={(newValue) => {
                  setDateRange2(
                    newValue ? newValue.format("YYYY-MM-DD") : null
                  );
                  setDateRange3(
                    newValue ? newValue.format("YYYY-MM-DD") : null
                  );
                }}
                slotProps={{
                  textField: {
                    placeholder: "End Date",
                    fullWidth: true,
                    hiddenLabel: true,
                  },
                }}
              />
            </LocalizationProvider>
          )}
        </div>
      </div>
      <div className="right_s">
        <Button className="btn btn_black" onClick={handleExport}>
          <FileDownloadIcon /> Export CSV
        </Button>
      </div>
    </div>
  );
}

export default ReportsTopbar;
